var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.iconType == 'b-icon')?_c('b-icon',{attrs:{"icon":_vm.iconValue,"scale":"2"}}):(_vm.iconType == 'img')?_c('img',{staticStyle:{"width":"100%"},attrs:{"src":_vm.iconValue}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }